import { render, staticRenderFns } from "./WidgetSettings.vue?vue&type=template&id=1ee78a62&scoped=true"
import script from "./WidgetSettings.vue?vue&type=script&lang=js"
export * from "./WidgetSettings.vue?vue&type=script&lang=js"
import style0 from "./WidgetSettings.vue?vue&type=style&index=0&id=1ee78a62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee78a62",
  null
  
)

export default component.exports